import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { ReactComponent as Pencil } from "assets/svg/pencil.svg";
import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";
import { formatPageName } from "utils/formatPageName";
import { useSelector } from "react-redux";
import * as selector from "store/selectors/assistantPages";
import { CustomSkeleton } from "../../../../components/CustomSkeleton";

interface ViewAssistantPageHeaderProps {
  pageCode?: assistantPageCodeEnum;
  handleOpenEdit: () => void;
}

const ViewAssistantPageHeader = ({
  pageCode,
  handleOpenEdit,
}: ViewAssistantPageHeaderProps) => {
  const theme = useTheme();
  const isLoading = useSelector(selector.isLoading);
  const { workflowVersion } = useSelector(selector.assistantPage);

  return (
    <Box
      sx={{
        p: "30px 40px",
        mb: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "white",
        border: "1px solid #F3F3F3",
        borderRadius: "6px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          mr: "70px",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            mr: "10px",
            wordBreak: "break-all",
          }}
        >
          {isLoading ? (
            <CustomSkeleton styles={{ width: "200px", mr: "10px" }} />
          ) : (
            formatPageName(pageCode)
          )}
        </Typography>

        {isLoading ? (
          <CustomSkeleton
            styles={{
              width: "50px",
              height: "35px",
              fontSize: "14px",
              mr: "70px",
            }}
          />
        ) : (
          <Box sx={{ mr: "70px", flexBasis: "fit-content", flexShrink: 0 }} />
        )}

        <Box sx={{ flexBasis: "200px", flexShrink: 0 }}>
          <Typography
            sx={{
              mb: "5px",
              color: theme.palette.secondary.main,
              fontSize: "12px",
              fontWeight: 600,
            }}
          >
            Workflow Version
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            {isLoading ? (
              <CustomSkeleton styles={{ width: "200px" }} />
            ) : (
              <>{workflowVersion}</>
            )}
          </Typography>
        </Box>
      </Box>

      <Button
        classes="mainIcon"
        onClick={handleOpenEdit}
        sx={{
          flexBasis: "195px",
          flexShrink: 0,
          display: "flex",
          gap: "15px",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: theme.palette.secondary.main,
        }}
      >
        <Pencil />
        <Typography
          sx={{
            color: "white",
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          EDIT PAGE
        </Typography>
      </Button>
    </Box>
  );
};

export default ViewAssistantPageHeader;
